import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import AccountCircle from '@material-ui/icons/AccountCircle';
import {TwitterShareButton} from 'react-share';

const styles = theme => ({
  icon: {
    marginRight: theme.spacing.unit * 2
  },
  paperNoShadow : {
    boxShadow:"0px 0px 0px",
    padding : "10px 0"
  }
});

class Status extends Component {
  render() {
    const {classes} = this.props;
    if (!this.props.userData || this.props.userData.length === 0) {
      return (<p>表示するデータがありません.</p>);
    }
    return (<div style={{padding:"16px"}}>
      <Typography component="h5" variant="h5" className={classes.typography}>
        あなたの統計
      </Typography>
      <div className="scroll" style={{padding:"16px 0"}}>
      <Paper className={classes.paper}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            <TableCell>ユーザー</TableCell>
            <TableCell>総ファイル数</TableCell>
            <TableCell>総ユーザー数</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow key={this.props.userData.userid}>
          <TableCell align="left">
            {this.props.userData.icon && <img src={this.props.userData.icon} width="24" alt={this.props.userData.screen_name} style={{borderRadius:"100%"}}/>}
            {!this.props.userData.icon && <AccountCircle />}
          </TableCell>
          <TableCell align="right">@{this.props.userData.screen_name}</TableCell>
          <TableCell align="right">{this.props.userData.filesCount} ({this.props.userData.filesCountRank}位)</TableCell>
          <TableCell align="right">{this.props.userData.userCount} ({this.props.userData.userCountRank}位)</TableCell>
        </TableRow>
      </TableBody>
      </Table>
      </Paper>
      </div>
      <Paper className={classes.paperNoShadow}>
        <TwitterShareButton
          url={"https://buster.poyashi.me/"}
          title={"クソリプバスターを使ってだいたい" + this.props.userData.userCount + "人くらいブロックしました!"}
          style={{color:"#3f51b5",cursor:"pointer",display:"inline-block"}}>
          Twitterでシェア
        </TwitterShareButton>
      </Paper>
      <Typography component="h5" variant="h5" className={classes.typography}>
        利用中ユーザーの統計
      </Typography>
      <div className="scroll" style={{padding:"16px 0"}}>
      <Paper className={classes.paper}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            <TableCell>ユーザー</TableCell>
            <TableCell>総ファイル数</TableCell>
            <TableCell>総ユーザー数</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{
            this.props.allData.map(row => (<TableRow key={row.userid}>
              <TableCell align="left">
                {row.icon && <img src={row.icon} width="24" alt={row.screen_name} style={{borderRadius:"100%"}}/>}
                {!row.icon && <AccountCircle />}
              </TableCell>
              <TableCell align="right">@{row.screen_name}</TableCell>
              <TableCell align="right">{row.filesCount} ({row.filesCountRank}位)</TableCell>
              <TableCell align="right">{row.userCount} ({row.userCountRank}位)</TableCell>
            </TableRow>))
          }</TableBody>
      </Table>
      </Paper>
      </div>
    </div>)
  }
}

Status.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Status);
